module.exports = __webpack_public_path__ + "03_veryshort_grey.32b697f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_veryshort_grey.png
// module id = BqAO
// module chunks = 0